<template>
  <data-table-pagination
    :page="Number(value) || 1"
    :total-rows="Number(totalRows) || 0"
    :per-page="Number(perPage) || 20"
    @change="changePage"
  />
</template>

<script>
import DataTablePagination from "@/component/common/DataTablePagination.vue"

export default {
  name: "MedhopPagination",
  components: { DataTablePagination },
  props: {
    value: { type: Number, default: 1 },
    totalRows: { type: Number, default: 0 },
    perPage: { type: Number, default: 20 },
  },
  methods: {
    changePage(page) {
      this.$emit("input", page)
      this.$emit("change", page)
      this.$emit("page-click", { preventDefault() {} }, page)
    },
  },
}
</script>
